import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Like, Repository } from 'typeorm';
import { ProfileService } from '../profile/profile.service';
import { DeleteYoutubeDTO, PaginationDto, YoutubeDTO } from './dto/youtube.dto';
import { LinkTypesEntity } from './link-types.entity';
import { AllYTubeResponseModel, YTubeResponseModel } from './youtube-module';
import { YoutubeEntity } from './youtube.entity';


@Injectable()
export class YoutubeService {
    constructor (
        @InjectRepository(YoutubeEntity)
        private ytRepo: Repository<YoutubeEntity>, 
        @InjectRepository(LinkTypesEntity)
        private lkRepo: Repository<LinkTypesEntity>,
        private profileService: ProfileService,
    ) {}    
    
    
    async createYoutubeLink(queryParams,ytDto:YoutubeDTO,request:Request): Promise<YTubeResponseModel> {
        const response = new YTubeResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const saved = await this.ytRepo.save(ytDto);
                const data = await this.ytRepo.findOne({
                    where:{Id:saved.Id}
                })
                if(saved) {
                    response.status = true;
                    response.data   = data;
                    response.statusCode = 50000;
                    response.internalMessage = 'Link saved successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Link not saved')
                }
            } else {
                const saved = await this.ytRepo.save(ytDto);
                const data = await this.ytRepo.findOne({
                    where:{Id:saved.Id}
                })
                if(saved) {
                    response.status = true;
                    response.data   = data;
                    response.statusCode = 50000;
                    response.internalMessage = 'Link saved successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Link not saved')
                }
            }      
            return response;
        } catch (error) {
            throw error;
        }
    }

    async updateYoutubeLink(queryParams, ytDto:YoutubeDTO,request:Request): Promise<YTubeResponseModel> {
        const response = new YTubeResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const updatedData = await this.ytRepo.update(ytDto.Id,ytDto);
                const data = await this.ytRepo.findOne({
                    where: {Id:ytDto.Id},
                });
                if(!updatedData) {
                    throw new ErrorResponse(99908,'Link record update failed')
                }                 
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Link record updated';
                response.intlCode = 11108;
                response.data = data;
            } else  {
                const updatedData = await this.ytRepo.update(ytDto.Id,ytDto);
                const data = await this.ytRepo.findOne({
                    where: {Id:ytDto.Id},
                });
                if(!updatedData) {
                    throw new ErrorResponse(99908,'Link record update failed')
                }                 
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Link record updated';
                response.intlCode = 11108;
                response.data = data;
            }
            return response;
        } catch (error) {
            throw error;
        }
    }
	
    async getAllLinks(ptDto:PaginationDto,request:Request):Promise<AllYTubeResponseModel> {
        const response = new AllYTubeResponseModel();
        try {
            const finalData: any[] = [];
            let ylData: any[] = []; 
            if(ptDto.apiVersion == 1) {
                const alTypes = await this.lkRepo.find({
                    where:{status:true},
                    order:{createdAt:'DESC'}
                })
                if(!alTypes) {
                    throw new ErrorResponse(99908,'Data not found')
                }

                const promises = alTypes.map(async (y) => {
                    const data = await this.ytRepo.find({
                        where: {status: true,linkType:y.Id},
                        order: { createdAt: 'DESC' },
                        skip:ptDto.skip,
                        take:10
                    });
                    const promises1 = data.map(async (d) => {
                        const user = await this.profileService.getUserByUId(d.createdUser);
                        if(user) {
                            var fname = user.firstName;
                            var pic = user.profilePic !=null?user.profilePic:'';
                        } else {
                            var fname ='';
                            var pic = '';
                        }
                        return {
                            Id: d.Id,
                            linkType:d.linkType,
                            youtubeLink:d.youtubeLink,
                            userId:d.createdUser,
                            createdAt:d.createdAt,
                            userName: fname != null ? fname :'',
                            profilePic:pic != '' ? `${process.env.WORKINGURL}/${pic}` : ''
                        }
                    })
                    const ylda = await Promise.all(promises1);
                    ylData =[];
                    ylda.map((f) => { 
                        ylData.push({
                            Id: f.Id,
                            linkType:f.linkType,
                            youtubeLink:f.youtubeLink,
                            userId:f.userId,
                            createdAt:f.createdAt,
                            userName:f.userName,
                            profilePic:f.profilePic
                        })
                    });  
                    return {
                        Id:y.Id,
                        title:y.title,
                        list:ylData
                    } 
                });  
                const da = await Promise.all(promises);
                da.map((f) => { 
                    finalData.push({
                        Id: f.Id,
                        title:f.title,
                        list:f.list 
                    })
                }); 
                response.status = true;
                response.data = finalData;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;              
            }  else {
                const alTypes = await this.lkRepo.find({
                    where:{status:true},
                    order:{createdAt:'DESC'}
                })
                if(!alTypes) {
                    throw new ErrorResponse(99908,'Data not found')
                }

                const promises = alTypes.map(async (y) => {
                    const data = await this.ytRepo.find({
                        where: {status: true,linkType:y.Id},
                        order: { createdAt: 'DESC' },
                        skip:ptDto.skip,
                        take:10
                    });
                    const promises1 = data.map(async (d) => {
                        const user = await this.profileService.getUserByUId(d.createdUser);
                        if(user) {
                            var fname = user.firstName;
                            var pic = user.profilePic !=null?user.profilePic:'';
                        } else {
                            var fname ='';
                            var pic = '';
                        }
                        return {
                            Id: d.Id,
                            linkType:d.linkType,
                            youtubeLink:d.youtubeLink,
                            userId:d.createdUser,
                            createdAt:d.createdAt,
                            userName: fname != null ? fname :'',
                            profilePic:pic != '' ? `${process.env.WORKINGURL}/${pic}` : ''
                        }
                    })
                    const ylda = await Promise.all(promises1);
                    ylData =[];
                    ylda.map((f) => { 
                        ylData.push({
                            Id: f.Id,
                            linkType:f.linkType,
                            youtubeLink:f.youtubeLink,
                            userId:f.userId,
                            createdAt:f.createdAt,
                            userName:f.userName,
                            profilePic:f.profilePic
                        })
                    });  
                    return {
                        Id:y.Id,
                        title:y.title,
                        list:ylData
                    } 
                });  
                const da = await Promise.all(promises);
                da.map((f) => { 
                    finalData.push({
                        Id: f.Id,
                        title:f.title,
                        list:f.list 
                    })
                }); 
                response.status = true;
                response.data = finalData;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;              
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async getLinkById(queryParam,Id,request:Request):Promise<YTubeResponseModel> {
        const response = new YTubeResponseModel();
        try {
            if(queryParam.apiVersion == 1) {
                const data = await this.ytRepo.findOne({
                        where: {Id:Id},
                });
                
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const user = await this.profileService.getUserByUId(data.createdUser);
                if(user) {
                    var fname = user.firstName;
                    var pic = user.profilePic !=null?user.profilePic:'';
                } else {
                    var fname ='';
                    var pic = '';
                }
                const finalData = {
                    Id:data.Id,
                    title:data.title,
                    linkType:data.linkType,
                    youtubeLink:data.youtubeLink,
                    userId:data.createdUser,
                    createdAt:data.createdAt,
                    userName: fname != null ? fname :'',
                    profilePic:pic != '' ? `${process.env.WORKINGURL}/${pic}` : ''
                }
                response.status = true;
                response.data = finalData;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;              
            }  else {
                const data = await this.ytRepo.findOne({
                        where: {Id:Id},
                });
                
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const user = await this.profileService.getUserByUId(data.createdUser);
                if(user) {
                    var fname = user.firstName;
                    var pic = user.profilePic !=null?user.profilePic:'';
                } else {
                    var fname ='';
                    var pic = '';
                }
                const finalData = {
                    Id:data.Id,
                    title:data.title,
                    linkType:data.linkType,
                    youtubeLink:data.youtubeLink,
                    userId:data.createdUser,
                    createdAt:data.createdAt,
                    userName: fname != null ? fname :'',
                    profilePic:pic != '' ? `${process.env.WORKINGURL}/${pic}` : ''
                }
                response.status = true;
                response.data = finalData;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;              
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async deleteLink(queryParams,delDto:DeleteYoutubeDTO, request:Request):Promise<YTubeResponseModel> {
        const response = new YTubeResponseModel();
        try {
            const updateRole = await this.ytRepo.update(delDto.Id, delDto);
            if(updateRole) {
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Link deleted successfully';
                response.intlCode = 11108;
            } else {
                throw new ErrorResponse(99998, 'Link delete failed')
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

}
